import loadableWithRetry from '../common/loadableWithRetry'

//const NavigationMenu = loadableWithRetry(() => import('./NavigationMenu'))

 import NavigationMenu from './NavigationMenu'

export default NavigationMenu;
